<template>
    <div class="project-funding">
        <div class="project-funding__content">
            <h4 class="project-funding__title">Ülevaade platvormist</h4>
            <p class="project-funding__paragraph">
                99math digiõppevara on loodud matemaatika praktiseerimiseks ja
                õpilastes motivatsiooni tõstmiseks matemaatika vastu. Seda
                õppeplatvormi on võimalik kasutada nii klassitunnis kui ka ka
                iseseisvalt harjutades. Läbi õpianalüütika pakub platvorm
                õpetajale paremat ülevaadet õpilaste arengust.
            </p>
            <h4 class="project-funding__title">Uuenduslik õppevara</h4>
            <p class="project-funding__paragraph">
                Koostöös matemaatikaõpetajatega töötasime välja õppevara, et
                kasvatada õpilaste huvi matemaatika vastu. Uuendusliku platvormi
                eesmärk on mängustamisvõtteid (gamification) kasutades luua
                õpilastes soov mängida seda õpimängu nii klassiruumis kui ka
                vabal ajal. Seeläbi soovime luua õpilastes tugeva vundamendi
                matemaatikas ning meeldivuse selle õppeaine vastu. Ühtlasi tõsta
                nende laste ja noorte tõenäosust, tänu tugevale vundamendile
                matemaatikas, töötada tulevikus tulusatel töökohtadel finants-
                või tehnoloogiasektoris, teaduses või äris.
            </p>
            <h4 class="project-funding__title">Õpiväljundid</h4>
            <p class="project-funding__paragraph">
                Projektiga loodi uuenduslik matemaatika õppevara, mis arvestab
                ainekava õpiväljundeid ja hõlbustab matemaatika õppimist. I
                kooliastmes aitab 99math saavutada 42 õpiväljundit ja II
                kooliastmes 66 õpiväljundit.
            </p>
            <h4 class="project-funding__title">Toetused</h4>
            <p class="project-funding__paragraph">
                99math digiõppevara loomist toetas SA Innove ja Euroopa
                Sotsiaalfond kahe projekti kaudu: 99math matemaatika platvorm
                1.-3. klassile summaga 24 381,85 € 99math matemaatika platvorm
                4.-6. klassile summaga 24 470,47 € Platvormi kasutamine
                koolidele on tasuta.
            </p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.project-funding {
    background-color: #ffffff;

    &__content {
        max-width: 750px;
        margin: auto;
        padding: 2rem 1rem 4rem;

        @include mq($w-min-desktop, min) {
            padding: 0 1rem 4rem;
        }
    }

    &__title {
        font-style: normal;
        font-weight: bold;
        font-size: 1.125rem;
        line-height: 1.375rem;
        text-align: center;
        color: #333333;
    }

    &__paragraph {
        font-style: normal;
        font-weight: normal;
        font-size: 1.125rem;
        line-height: 1.375rem;
        text-align: center;
        color: #333333;
        margin: 0.5rem auto 2rem;
    }
}
</style>
